<template>
  <div id="app" class="min-h-screen bg-[#0f0e1e] overflow-x-hidden">
    <nav-bar />
    <main class="pt-14 md:pt-16 px-4 md:px-8">
      <router-view></router-view>
    </main>
    <app-footer />
  </div>
</template>

<script setup>
import NavBar from './components/NavBar.vue'
import AppFooter from './components/AppFooter.vue'
</script>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;
@use '@fortawesome/fontawesome-free/css/all.min.css';
</style>
